import React, { useState } from "react";

import { useFormContext } from "react-hook-form";
import PropTypes, { string } from "prop-types";
import { Modal } from "react-bootstrap";
import { Switch, TimePicker } from "antd";
import dayjs from "dayjs";
import Select from "react-select";
import { toast } from "core/Operations/toast";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const timeLogOptions = [
  { id: "1", label: "Punch", value: "Punch" },
  { id: "2", label: "Manual Entry", value: "ManualEntry" },
  { id: "3", label: "Absent", value: "Absent" },
  { id: "4", label: "Paid Off", value: "PaidOff" },
  { id: "5", label: "Weekly Off", value: "WeeklyOff" },
];
const TimeLogOptions = ({
  employeeName = "",
  id,
  onSubmit,
  show = false,
  handleClose,
  shiftOptions,
}) => {
  //   const {
  //     register,
  //     handleSubmit,
  //     formState: { errors },
  //     watch,
  //     trigger,
  //     setValue,
  //   } = useFormContext();

  const [shift, setShift] = React.useState(null);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);

  const [timelogOption, setTimelogOption] = React.useState(null);
  const [isHalfDay, setIsHalfDay] = React.useState(false);
  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);

  const handleTimeChange = ({ type, value }) => {
    if (type === "startTime") setStartTime(value);
    if (type === "endTime") setEndTime(value);
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    if (!timelogOption) {
      toast.warning("Please select Time Log Option");
      return;
    }

    if (isHalfDay) {
      if (!shift) {
        toast.warning("Please select Shift");
        return;
      }

      if (!selectedSession) {
        toast.warning("Please select Session");
        return;
      }

      if (!startTime || !endTime) {
        toast.warning("Please select In Time and Out Time");
        return;
      }
    }
    const selShift = shift ? shift.shiftPolicyID : null;
    await onSubmit(timelogOption, isHalfDay, id, startTime, endTime, selShift);
    setTimelogOption(null);
    setIsHalfDay(false);
    setStartTime(null);
    setEndTime(null);
  };

  const onShiftSelect = (selectedShift) => {
    console.log(selectedShift);
    setShift(selectedShift);

    setSelectedSession(null);
    setStartTime(null);
    setEndTime(null);

    setSessionOptions([
      {
        value: 1,
        label: `First Half (${selectedShift.shiftStartTime} - ${selectedShift.shift1stHalfDayEndTime})`,
      },
      {
        value: 2,
        label: `Second Half (${selectedShift.shift2ndHalfDayStartTime} - ${selectedShift.shiftEndTime})`,
      },
    ]);
  };
  const onSessionSelect = (selectedSession) => {
    setSelectedSession(selectedSession);

    if (!shift) return;

    if (selectedSession.value === 1) {
      setStartTime(shift.shiftStartTime);
      setEndTime(shift.shift1stHalfDayEndTime);
    } else {
      setStartTime(shift.shift2ndHalfDayStartTime);
      setEndTime(shift.shiftEndTime);
    }
  };

  const selectAllText = (e) => {
    if (e.target && e.target.select) {
      e.target.select();
    }
  };

  const handleInput = (e) => {
    const allowed = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ":",
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ];
    if (!allowed.includes(e.key)) {
      e.preventDefault(); // block unwanted keys
    } else {
      let value = e.target.value.replace(/[^0-9]/g, "");
      if (value.length >= 3) {
        value = value.slice(0, 2) + ":" + value.slice(2, 4);
      }
      e.target.value = value;
    }
  };

  const onChange = (time, type) => {
    const fullTimeString = time ? time.format("HH:mm:ss") : null;
    handleTimeChange({
      type: type,
      value: fullTimeString,
    });
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Employee : {employeeName}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmitHandler} className="needs-validation">
          <div className="form-row justify-content-between">
            {timeLogOptions.map((option) => (
              <div
                className="form-check"
                key={option.id}
                style={{ padding: "5px 30px" }}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="TimeLogOption"
                  id={option.value}
                  value={option.value}
                  onChange={(e) => {
                    setTimelogOption(e.target.value);
                    // setValue(
                    //   `attendance[${id}].timeLogOption`,
                    //   e.target.value
                    // );
                  }}
                />
                <label className="form-check-label" htmlFor={option.value}>
                  {option.label}
                </label>
              </div>
            ))}
            <hr />
            <div className="">
              <Switch
                checkedChildren="Yes"
                unCheckedChildren="No"
                defaultChecked={false}
                style={{
                  caretColor: "#002299",
                }}
                // className="form-check-input"
                onChange={(e) => setIsHalfDay(e)}
              />

              <label className="form-check-label" htmlFor="switch-md">
                &nbsp;Half Day
              </label>
              {isHalfDay && (
                <div className="row form-row mt-3">
                  <div className="col-md-6">
                    <label className="form-label">Shift</label>
                    <Select
                      options={shiftOptions}
                      value={shift}
                      onChange={onShiftSelect}
                    />
                  </div>
                  {sessionOptions && sessionOptions.length > 0 && (
                    <div className="col-md-6">
                      <label className="form-label">Session</label>
                      <Select
                        options={sessionOptions}
                        value={selectedSession}
                        onChange={onSessionSelect}
                      />
                    </div>
                  )}
                  {selectedSession && (
                    <>
                      <div className="col-md-6">
                        <label className="form-label">In Time</label>
                        <TimePicker
                          value={startTime ? dayjs(startTime, "HH:mm") : null}
                          format="HH:mm"
                          // variant="borderless"
                          allowClear={true}
                          onMouseEnter={selectAllText}
                          onFocus={selectAllText}
                          onClick={selectAllText}
                          onKeyDown={handleInput}
                          onChange={(e) => onChange(e, "startTime")}
                          className="form-control"
                          // onInput={(e) => onInput(e, "startTime")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          required={isHalfDay}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Out Time</label>
                        <TimePicker
                          value={endTime ? dayjs(endTime, "HH:mm") : null}
                          format="HH:mm"
                          // variant="borderless"
                          allowClear={true}
                          onMouseEnter={selectAllText}
                          onFocus={selectAllText}
                          onClick={selectAllText}
                          onKeyDown={handleInput}
                          onChange={(e) => onChange(e, "endTime")}
                          className="form-control"
                          // onInput={(e) => onInput(e, "startTime")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          required={isHalfDay}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button type="submit" className="btn btn-added">
              Create
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

TimeLogOptions.propTypes = {
  employeeName: PropTypes.string,
  id: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  shiftOptions: PropTypes.array.isRequired,
};

export default React.memo(TimeLogOptions);
